import {routes} from './routes'

export const updateDeskingData = (axios, dealershipId, payload, vin) => {
  return axios.post(`${routes.desking.base}/${dealershipId}/${vin}`, payload)
}
